export const EVENT = {
    GET_EVENT: "user/GET_EVENT",
};
